import React from 'react';
import Proptypes from 'prop-types';
import Icon from '../Icon';
import './style.css';

const PlayButton = ({ className, ...otherProps }) => {
  return (
    <button className={`play-button ${className}`} {...otherProps}>
      <Icon name="fas fa-play " />
      <div className="play-button-wave wave1" />
      <div className="play-button-wave wave2" />
      <div className="play-button-wave wave3" />
    </button>
  );
};

PlayButton.propTypes = {
  className: Proptypes.string
};

PlayButton.defaultProps = {
  className: ''
};

export default PlayButton;



// WEBPACK FOOTER //
// ./src/Components/Button/PlayButton.js